export default {
  title: 'Kies een pakket voor je',
  title_light: ' werk-BV',
  subtitle: '...  your BV for',
  description:
    'Pak je voordeel met een pakket voor je werk-BV. Bespaar geld en tijd met met 100+ contracten en juridische advies van advocaten.'
};
